import { View, Text, TouchableOpacity, ScrollView, Modal, Dimensions, StyleSheet } from "react-native";
import React, { useState, useEffect } from "react";
import { Ionicons } from "@expo/vector-icons";
// import PassesComponent from "../PassesComponent";
import { useQuery } from "convex/react";
import { api } from "../../convex/_generated/api";
import { colors, fontFamily } from "../../constants/theme";

const RestaurantTabsComponent = ({
  selectedRestaurant,
  initialTab,
  // Passes tab (commented out) — restore when uncommenting renderPassesModal + Passes tab below
  // doesUserHaveMembership,
  // getUserMembership,
  // handleBenefitPress,
  // getNextMembershipTier,
  // getCurrentMembershipTier,
  // handleMissingPerk,
  // userDoc,
  // onUsePass,
  // onCloseUsePassModal,
  /** e.g. Hours button — rendered after Specials */
  endSlot,
}) => {
  const [activeModal, setActiveModal] = useState(null);

  // Open Specials modal when requested (e.g. from Social "This Week"); Shared Bites is inline on the sheet
  useEffect(() => {
    if (!initialTab || !selectedRestaurant?._id) return;
    if (initialTab !== "Specials") return;
    // Passes tab: use `if (initialTab !== "Specials" && initialTab !== "Passes") return;`
    const t = setTimeout(() => setActiveModal(initialTab), 300);
    return () => clearTimeout(t);
  }, [initialTab, selectedRestaurant?._id]);

  const dailySpecials = useQuery(
    api.getDailySpecials.getDailySpecialsByRestaurant,
    selectedRestaurant?._id
      ? {
          restaurantId: selectedRestaurant._id,
        }
      : "skip"
  );

  const getAbbreviatedDay = (day) => {
    const abbreviations = {
      Monday: "Mon",
      Tuesday: "Tue",
      Wednesday: "Wed",
      Thursday: "Thu",
      Friday: "Fri",
      Saturday: "Sat",
      Sunday: "Sun",
    };
    return abbreviations[day] || day;
  };

  const tabs = [
    { id: "Specials", label: "Specials", icon: "pricetag-outline" },
    // { id: "Passes", label: "Passes", icon: "ticket-outline" },
  ];

  const handleTabPress = (tabId) => {
    setActiveModal(tabId);
  };

  const closeModal = () => {
    setActiveModal(null);
  };

  const modalCloseFooter = (
    <View style={styles.passesModalFooter}>
      <TouchableOpacity
        style={styles.passesModalCloseBtn}
        onPress={closeModal}
        activeOpacity={0.88}
        accessibilityRole="button"
        accessibilityLabel="Close"
      >
        <Text style={styles.passesModalCloseBtnText}>Close</Text>
      </TouchableOpacity>
    </View>
  );

  const renderSpecialsModal = () => {
    const screenHeight = Dimensions.get("window").height;

    const specialsHeader = (
      <View style={styles.passesModalHeader}>
        <View style={styles.passesModalIconWrap}>
          <Ionicons name="pricetag-outline" size={22} color={colors.disgoBrown} />
        </View>
        <Text style={styles.passesModalTitle}>Specials</Text>
        <Text style={styles.passesModalSubtitle}>Daily deals & happy hour</Text>
      </View>
    );

    return (
      <Modal
        visible={activeModal === "Specials"}
        animationType="fade"
        transparent={true}
        onRequestClose={closeModal}
      >
        <View style={styles.passesModalRoot}>
          <TouchableOpacity activeOpacity={1} onPress={closeModal} style={styles.modalBackdrop} />
          <View style={[styles.passesModalCard, { height: screenHeight * 0.72 }]}>
            {specialsHeader}
            <ScrollView
              style={styles.passesModalScroll}
              contentContainerStyle={styles.passesModalScrollContent}
              showsVerticalScrollIndicator={true}
              bounces
            >
              {dailySpecials ? (
                dailySpecials.length > 0 ? (
                  <View style={styles.specialsTableCard}>
                    <View style={[styles.tableHeaderRow, { backgroundColor: "rgba(156, 107, 66, 0.12)" }]}>
                      <View style={styles.col15}>
                        <Text style={styles.tableHeaderText}>Day</Text>
                      </View>
                      <View style={styles.col30}>
                        <Text style={styles.tableHeaderText}>Time</Text>
                      </View>
                      <View style={styles.col55}>
                        <Text style={styles.tableHeaderText}>Special</Text>
                      </View>
                    </View>
                    {dailySpecials.map((special, index) => (
                      <View
                        key={special.dayOfWeek}
                        style={[
                          styles.tableRow,
                          {
                            backgroundColor: index % 2 === 0 ? colors.white : "rgba(156, 107, 66, 0.08)",
                          },
                        ]}
                      >
                        <View style={[styles.col15, styles.pr2]}>
                          <Text style={styles.cellTextBold}>{getAbbreviatedDay(special.dayOfWeek)}</Text>
                        </View>
                        <View style={[styles.col30, styles.pr2]}>
                          <Text style={styles.cellText} numberOfLines={2}>
                            {special.whenHH}
                          </Text>
                        </View>
                        <View style={styles.col55}>
                          <Text style={styles.cellText} numberOfLines={3}>
                            {special.description}
                          </Text>
                        </View>
                      </View>
                    ))}
                  </View>
                ) : (
                  <View style={styles.specialsEmptyWrap}>
                    <Ionicons name="pricetag-outline" size={40} color={colors.gray400} />
                    <Text style={styles.passesModalEmptyTitle}>No specials yet</Text>
                    <Text style={styles.passesModalEmptySubtitle}>
                      This restaurant hasn't added daily specials.
                    </Text>
                  </View>
                )
              ) : (
                <View style={styles.specialsEmptyWrap}>
                  <Text style={styles.loadingText}>Loading specials...</Text>
                </View>
              )}
            </ScrollView>
            {modalCloseFooter}
          </View>
        </View>
      </Modal>
    );
  };

  /*
  const renderPassesModal = () => {
    const screenHeight = Dimensions.get("window").height;

    const passesHeader = (
      <View style={styles.passesModalHeader}>
        <View style={styles.passesModalIconWrap}>
          <Ionicons name="ticket-outline" size={22} color={colors.disgoBrown} />
        </View>
        <Text style={styles.passesModalTitle}>Passes</Text>
        <Text style={styles.passesModalSubtitle}>Membership perks & offers</Text>
      </View>
    );

    if (!selectedRestaurant?._id) {
      return (
        <Modal
          visible={activeModal === "Passes"}
          animationType="fade"
          transparent={true}
          onRequestClose={closeModal}
        >
          <View style={styles.passesModalRoot}>
            <TouchableOpacity activeOpacity={1} onPress={closeModal} style={styles.modalBackdrop} />
            <View style={[styles.passesModalCard, { height: screenHeight * 0.72 }]}>
              {passesHeader}
              <View style={styles.passesModalEmptyBody}>
                <Ionicons name="location-outline" size={40} color={colors.gray400} />
                <Text style={styles.passesModalEmptyTitle}>No restaurant selected</Text>
                <Text style={styles.passesModalEmptySubtitle}>Choose a place on the map to see passes.</Text>
              </View>
              {modalCloseFooter}
            </View>
          </View>
        </Modal>
      );
    }

    return (
      <Modal
        visible={activeModal === "Passes"}
        animationType="fade"
        transparent={true}
        onRequestClose={closeModal}
      >
        <View style={styles.passesModalRoot}>
          <TouchableOpacity activeOpacity={1} onPress={closeModal} style={styles.modalBackdrop} />
          <View style={[styles.passesModalCard, { height: screenHeight * 0.72 }]}>
            {passesHeader}
            <ScrollView
              style={styles.passesModalScroll}
              contentContainerStyle={styles.passesModalScrollContent}
              showsVerticalScrollIndicator={true}
              bounces
            >
              <PassesComponent
                restaurantId={selectedRestaurant._id}
                userDoc={userDoc}
                getUserMembership={getUserMembership}
                selectedRestaurant={selectedRestaurant}
                onUsePass={onUsePass}
                onCloseUsePassModal={onCloseUsePassModal}
                forceExpanded={true}
              />
            </ScrollView>
            {modalCloseFooter}
          </View>
        </View>
      </Modal>
    );
  };
  */

  return (
    <View style={styles.tabBarWrap}>
      <View style={styles.tabRow}>
        {tabs.map((tab) => (
          <TouchableOpacity key={tab.id} onPress={() => handleTabPress(tab.id)} style={styles.tabBtn}>
            <Ionicons name={tab.icon} size={18} color={colors.disgoBrown} />
            <Text style={styles.tabLabel}>{tab.label}</Text>
          </TouchableOpacity>
        ))}
        {endSlot}
      </View>

      {renderSpecialsModal()}
      {/* {renderPassesModal()} */}
    </View>
  );
};

const styles = StyleSheet.create({
  modalBackdrop: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  specialsTableCard: {
    backgroundColor: colors.white,
    borderRadius: 12,
    overflow: "hidden",
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: colors.gray200,
  },
  specialsEmptyWrap: {
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: 32,
    paddingHorizontal: 16,
    gap: 10,
  },
  tableHeaderRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingVertical: 8,
    paddingHorizontal: 12,
    borderBottomWidth: 1,
    borderBottomColor: colors.gray200,
  },
  tableHeaderText: { fontFamily: fontFamily.abhayaBold, fontSize: 14, color: colors.gray600 },
  tableRow: { flexDirection: "row", justifyContent: "space-between", paddingVertical: 8, paddingHorizontal: 12 },
  col15: { width: "15%" },
  col30: { width: "30%" },
  col55: { width: "55%" },
  pr2: { paddingRight: 8 },
  cellTextBold: { fontFamily: fontFamily.abhayaBold, fontSize: 16, color: colors.black },
  cellText: { fontFamily: fontFamily.abhaya, fontSize: 16, color: colors.black },
  loadingText: { fontSize: 16, fontFamily: fontFamily.abhaya, padding: 12, color: colors.black },
  passesModalRoot: {
    flex: 1,
    justifyContent: "center",
    paddingVertical: 24,
  },
  passesModalCard: {
    backgroundColor: colors.white,
    borderRadius: 24,
    marginHorizontal: 16,
    overflow: "hidden",
    flexDirection: "column",
  },
  passesModalHeader: {
    alignItems: "center",
    paddingTop: 22,
    paddingBottom: 16,
    paddingHorizontal: 20,
    backgroundColor: colors.cream2,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: colors.gray200,
  },
  passesModalIconWrap: {
    width: 44,
    height: 44,
    borderRadius: 22,
    backgroundColor: colors.ratingChipBg,
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 10,
  },
  passesModalTitle: {
    fontSize: 26,
    fontFamily: fontFamily.abhayaBold,
    color: colors.black,
    letterSpacing: -0.3,
  },
  passesModalSubtitle: {
    marginTop: 4,
    fontSize: 15,
    fontFamily: fontFamily.abhaya,
    color: colors.gray600,
  },
  passesModalScroll: {
    flex: 1,
    backgroundColor: colors.cream2,
  },
  passesModalScrollContent: {
    paddingHorizontal: 12,
    paddingTop: 12,
    paddingBottom: 12,
    flexGrow: 1,
  },
  passesModalEmptyBody: {
    flex: 1,
    minHeight: 160,
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: 28,
    paddingVertical: 24,
    backgroundColor: colors.cream2,
    gap: 10,
  },
  passesModalEmptyTitle: {
    fontSize: 18,
    fontFamily: fontFamily.abhayaBold,
    color: colors.gray600,
    textAlign: "center",
  },
  passesModalEmptySubtitle: {
    fontSize: 15,
    fontFamily: fontFamily.abhaya,
    color: colors.gray500,
    textAlign: "center",
    lineHeight: 22,
  },
  passesModalFooter: {
    paddingHorizontal: 16,
    paddingTop: 12,
    paddingBottom: 20,
    backgroundColor: colors.white,
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: colors.gray200,
  },
  passesModalCloseBtn: {
    backgroundColor: colors.brownMuted,
    borderRadius: 12,
    paddingVertical: 15,
    alignItems: "center",
    justifyContent: "center",
  },
  passesModalCloseBtnText: {
    fontSize: 18,
    fontFamily: fontFamily.abhayaBold,
    color: colors.white,
  },
  tabBarWrap: { marginTop: 8, width: "100%", alignSelf: "stretch" },
  tabRow: {
    width: "100%",
    flexDirection: "row",
    alignItems: "stretch",
    gap: 10,
  },
  tabBtn: {
    flex: 1,
    minWidth: 0,
    flexDirection: "row",
    paddingVertical: 12,
    paddingHorizontal: 12,
    alignItems: "center",
    justifyContent: "center",
    gap: 6,
    backgroundColor: colors.tabChipMutedBg,
    borderRadius: 8,
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: colors.tabChipBorder,
  },
  tabLabel: { fontSize: 16, fontFamily: fontFamily.abhayaBold, color: colors.disgoBrown, fontWeight: "600" },
});

export default RestaurantTabsComponent;
